module.exports = __webpack_public_path__ + "3c05bf4df0fd4c74e48807a7c011acac.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/Footer2/Testimonials/BDA.png
// module id = 559
// module chunks = 16